

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GridModule } from '@syncfusion/ej2-angular-grids';
import { MyDatePickerModule } from 'mydatepicker';
import { DropDownListAllModule } from '@syncfusion/ej2-angular-dropdowns';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { MaskedTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { SupportPlannerRoutingModule } from './supportplanner-routing.module';
import { SupportplannerComponent } from './supportplanner.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { GetHTTPService } from './supportplannerdata.service';
import { supportService } from './supportplanner.service';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';


@NgModule({
  declarations: [
    SupportplannerComponent,

  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    GridModule,
    MyDatePickerModule,
    DropDownListAllModule,
    NgxUiLoaderModule,
    MaskedTextBoxModule,
    SupportPlannerRoutingModule,
    NgSelectModule
  ],
  providers: [GetHTTPService, supportService],
  exports:[SupportplannerComponent]
})
export class SupportplannerModule { }
